module.exports = __webpack_public_path__ + "static/img/unapproved.3e6fe6ba.svg";